import { Datagrid, DateField, List, ReferenceField, TextField, TextInput } from 'react-admin';

const taskFilters = [
    <TextInput source="q" label="Search" alwaysOn />,
];

export const TaskList = () => (
    <List perPage={50} sort={{ field: 'submit_ts', order: 'DESC' }} filters={taskFilters}>
        <Datagrid>
            <ReferenceField source="device_id" reference="devices" />
            <TextField source="device_id" />
            <TextField source="imei" />
            <TextField source="task_type" />
            <TextField source="description" />
            <TextField source="status" />
            <DateField label="Submit Time" source="submit_ts" showTime />
            <DateField label="Complete Time" source="finish_ts" showTime />
            <TextField label="Complete Status" source="result.verbose" />
        </Datagrid>
    </List>
);
